import { Form, Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { FlightSearchModel } from "../../model/FlightSearchModel";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import { UtilService } from "../../services/shared/UtilService";
import { msgTypes } from "../../constants/msgTypes";
import Header from "../../sharedScreens/Header";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import dayjs, { Dayjs } from "dayjs";
import MuiRadioButton from "../../components/basicComponent/MuiRAdioButton";
import { flightOptions, travelClass } from "../../constants/constant";
import { List } from "../../constants/constant";
import { useNavigate } from "react-router-dom";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import { flightSearchSchema } from "../../validations/Schema";
import PriceCalender from "../../components/basicComponent/PriceCalender";
import { useFlightSearch } from "../../services/context/FlightSearchContext";

const FlightSearch = () => {
  const [airportList, setAirportList] = useState<List[]>([]);
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const navigate = useNavigate();
  const [sector, setSector] = useState<string[]>(["", ""]); //SET THE DEFAULT VALUE OF SECTOR PLEASE DO NOT REMOVE THESE TWO EMPTY STRINGS
  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    localStorage.removeItem("flight_recent_search");
    getAirportList();
  }, []);

  const formik = useFormik({
    initialValues: new FlightSearchModel(),
    enableReinitialize: true,
    validationSchema: flightSearchSchema,
    onSubmit(values, formikHelpers) {
      localStorage.setItem("flight_recent_search", JSON.stringify(values));

      setIsSubmitted(true); // <-- enable error display
      navigate("/flightlist", {
        state: { values },
      });
    },
  });

  const getAirportList = async () => {
    try {
      const response = await UtilService.getAirport();

      if (response.statusMsg === msgTypes.SUCCESS.msg) {
        const arr = response?.data?.map(
          (i: { airportName: any; airportCode: any }) => ({
            label: i?.airportName + " (" + i?.airportCode + ")",
            value: i?.airportName,
            code: i?.airportCode,
          })
        );

        setAirportList(arr);
      }
    } catch (error) {
      console.error("Error fetching airport list:", error);
    }
  };

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue("travelClass", e.target.value);
    if (e.target.value === "Economy") {
      formik.setFieldValue("cabin", 0);
    } else if (e.target.value === "Premium Economy") {
      formik.setFieldValue("cabin", 4);
    } else if (e.target.value === "Business") {
      formik.setFieldValue("cabin", 2);
    } else if (e.target.value === "First Class") {
      formik.setFieldValue("cabin", 1);
    }
  };

  const handleDone = () => {
    const travellers =
      formik.values.adults + formik.values.child + formik.values.infants;
    const travellersDetail = `${travellers} Travellers - ${formik.values.travelClass}`;
    formik.setFieldValue("travellersDetail", travellersDetail);
    setIsPopupOpen(false);
    closePopup();
  };

  const addSector = () => {
    setSector([...sector, `Sector ${sector.length + 1}`]);
  };

  const removeSector = () => {
    if (sector.length > 0) {
      setSector(sector.slice(0, -1)); // Removes the last item
    }
  };

  const [rotated, setRotated] = useState(false);
  const handleSwap = () => {
    const origin = formik.values.origin;
    const originCode = formik.values.originCode;
    const destination = formik.values.destination;
    const destinationCode = formik.values.destinationCode;

    // Swap the values
    formik.setFieldValue("origin", destination);
    formik.setFieldValue("originCode", destinationCode);
    formik.setFieldValue("destination", origin);
    formik.setFieldValue("destinationCode", originCode);

    setRotated(!rotated);
    // Optionally reset the touched state
    formik.setFieldTouched("origin", false);
    formik.setFieldTouched("destination", false);
  };

  console.log("formik.errors", formik.values.fromDate);

  return (
    <>
      <div className=" grow">
        <SideMenu />
        <div className="wrapper flex grow flex-col">
          <Header />
          <main className="grow content" id="content" role="content">
            <div className="container-fixed">
              <div className="card-header mb-1">
                <h3 className="card-title titlecolorr"> Flight Search</h3>
              </div>
              <div className="card card-custom">
                <div className="card-body">
                  <MuiRadioButton
                    name="radio-options"
                    value={formik.values.tripType}
                    options={flightOptions}
                    onChange={(value) => {
                      formik.setFieldValue("tripType", value);
                      if (value === "One way") {
                        formik.setFieldValue("tripTypeNumber", 0);
                        // formik.setFieldValue("fromDate", "");
                        // Clear to date when switching to one way
                        formik.setFieldValue("toDate", "");
                      } else if (value === "Round Trip") {
                        formik.setFieldValue("tripTypeNumber", 1);
                        // formik.setFieldValue("fromDate", "");
                        formik.setFieldValue("toDate", "");
                      }
                    }}
                    direction="row"
                    isInvalid={false}
                    errorText="Please select an option"
                    isRequired={true}
                  />

                  {formik.values.tripType === "Multicity" ? (
                    <div className="row mt-3">
                      {sector?.map((sector, index) => (
                        <div key={index} className="row">
                          <div className="col-md-4 mb-4">
                            <div className="">
                              <MuiSearchSelect
                                placeholder="Enter Origin"
                                onChange={(value, id, data) => {
                                  formik.setFieldValue("origin", value);
                                  formik.setFieldValue("originCode", data.code);
                                }}
                                options={airportList}
                                label="Enter Origin"
                                value={formik.values.origin}
                                isRequired={true}
                                errorText={
                                  formik.touched.origin && formik.errors.origin
                                    ? formik.errors.origin
                                    : ""
                                }
                                isInvalid={
                                  formik.touched.origin &&
                                  Boolean(formik.errors.origin)
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4 mb-4">
                            <div className="">
                              <MuiSearchSelect
                                placeholder="Enter Destination"
                                onChange={(value, id, data) => {
                                  formik.setFieldValue("destination", value);
                                  formik.setFieldValue(
                                    "destinationCode",
                                    data.code
                                  );
                                }}
                                options={airportList}
                                label="Enter Destination"
                                value={formik.values.destination}
                                isRequired={true}
                                errorText={
                                  formik.touched.destination &&
                                  formik.errors.destination
                                    ? formik.errors.destination
                                    : ""
                                }
                                isInvalid={
                                  formik.touched.destination &&
                                  Boolean(formik.errors.destination)
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-4 mb-3">
                            <MuiDatePicker
                              label="Departure Date"
                              value={
                                formik.values.fromDate
                                  ? dayjs(formik.values.fromDate)
                                  : null
                              }
                              onChange={(date: string) => {
                                formik.setFieldValue("fromDate", date);
                              }}
                              isRequired={true}
                              // onBlur={() => formik.setFieldTouched("fromDate", true)} // Mark as touched
                              isError={
                                formik.touched.fromDate &&
                                Boolean(formik.errors.fromDate)
                              }
                              errorText={
                                formik.touched.fromDate
                                  ? formik.errors.fromDate
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      ))}

                      <div className="row">
                        <div className="text-center">
                          <button
                            className="add-sector-btn"
                            onClick={addSector}
                          >
                            <i className="fa-solid fa-plus"></i> ADD SECTOR
                          </button>
                          {sector?.length >= 3 && (
                            <button
                              className="add-sector-btn mx-2"
                              onClick={removeSector}
                            >
                              <i className="fa-solid fa-xmark"></i>
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4 my-4">
                        <div>
                          <MuiInput
                            placeholder="Enter Customer Name"
                            label="Customer Name"
                            isRequired={true}
                            isInvalid={
                              formik.touched.customerName &&
                              Boolean(formik.errors.customerName)
                            }
                            errorText={
                              formik.touched.customerName &&
                              formik.errors.customerName
                                ? formik.errors.customerName
                                : ""
                            }
                            onChange={(e: any) =>
                              formik.setFieldValue("customerName", e)
                            }
                            onBlur={() =>
                              formik.setFieldTouched("customerName", true)
                            }
                            value={formik.values.customerName}
                          />
                        </div>
                      </div>

                      <div className="col-md-4 my-4">
                        <div className="">
                          <MuiInput
                            placeholder="Enter Traveller(s), Class"
                            label="Traveller(s), Class"
                            isRequired={true}
                            isInvalid={
                              formik.touched.travellersDetail &&
                              Boolean(formik.errors.travellersDetail)
                            }
                            errorText={
                              formik.touched.travellersDetail &&
                              formik.errors.travellersDetail
                                ? formik.errors.travellersDetail
                                : ""
                            }
                            onClick={() => openPopup()}
                            onChange={(e: any) =>
                              formik.setFieldValue("travellersDetail", e)
                            }
                            onBlur={() =>
                              formik.setFieldTouched("travellersDetail", true)
                            }
                            value={formik.values.travellersDetail}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <div>
                          {/* <FormikControl
                                control="radioButton"
                                value={selectedOption}
                                onChange={handleRadioChange}
                                options={options}
                                className="radiobutton"
                              /> */}
                        </div>
                      </div>

                      <div className="col-md-6 mb-4 origin-div">
                        <div className="">
                          <MuiSearchSelect
                            placeholder="Enter Origin"
                            onChange={(value, id, data) => {
                              formik.setFieldTouched("origin", false);
                              formik.setFieldValue("origin", value);
                              formik.setFieldValue("originCode", data?.code);
                            }}
                            options={airportList}
                            label="Enter Origin"
                            value={formik.values.origin}
                            isRequired={true}
                            errorText={
                              formik.touched.origin && formik.errors.origin
                                ? formik.errors.origin
                                : ""
                            }
                            isInvalid={
                              formik.touched.origin &&
                              Boolean(formik.errors.origin)
                            }
                          />
                        </div>
                      </div>

                      <div className="interchange" onClick={handleSwap}>
                        <img
                          src="media/images/arrow.png"
                          alt="arrow.png"
                          className={`transition-transform ${
                            rotated ? "rotate-180" : ""
                          }`}
                          style={{
                            transition: "transform 0.3s ease",
                            transform: rotated
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            cursor: "pointer",
                          }}
                        />
                      </div>

                      <div className="col-md-6 mb-4 origin-div desti-div flight-err">
                        <div className="">
                          <MuiSearchSelect
                            placeholder="Enter Destination"
                            onChange={(value, id, data) => {
                              formik.setFieldTouched("destination", false);
                              formik.setFieldValue("destination", value);
                              formik.setFieldValue(
                                "destinationCode",
                                data?.code
                              );
                            }}
                            options={airportList}
                            label="Enter Destination"
                            value={formik.values.destination}
                            isRequired={true}
                            errorText={(
                              formik.touched.destination &&
                              formik.errors.destination
                            )?.toString()}
                            isInvalid={
                              formik.touched.destination &&
                              !!formik.errors.destination
                            }
                          />
                        </div>
                      </div>

                      {/* From Date - Always visible for One way and Round Trip */}
                      <div className="col-md-4 mb-4">
                        <PriceCalender
                          isRequired={true}
                          value={
                            formik.values.fromDate
                              ? dayjs(formik.values.fromDate)
                              : null
                          }
                          onChange={(date: Dayjs) => {
                            console.log("date", date);

                            formik.setFieldValue(
                              "fromDate",
                              dayjs(date).format("YYYY-MM-DD")
                            );
                          }}
                          label="Departure Date"
                          originCode={formik.values.originCode}
                          destinationCode={formik.values.destinationCode}
                          onBlur={() => formik.setFieldTouched("fromDate")}
                          isError={Boolean(
                            formik.touched.fromDate && formik.errors.fromDate
                          )}
                          errorText={
                            formik.touched.fromDate && formik.errors.fromDate
                              ? formik.errors.fromDate
                              : ""
                          }
                        />
                      </div>

                      {/* To Date - Only visible for Round Trip */}
                      {formik.values.tripType === "Round Trip" && (
                        <div className="col-md-4 mb-3">
                          <PriceCalender
                            isRequired={true}
                            value={
                              formik.values.toDate
                                ? dayjs(formik.values.toDate)
                                : null
                            }
                            fromDate={
                              formik.values.fromDate
                                ? dayjs(formik.values.fromDate)
                                : null
                            }
                            onChange={(date: Dayjs) => {
                              formik.setFieldValue(
                                "toDate",
                                dayjs(date).format("YYYY-MM-DD")
                              );
                            }}
                            label="Return Date"
                            originCode={formik.values.originCode}
                            destinationCode={formik.values.destinationCode}
                            isError={
                              (isSubmitted || formik.touched.toDate) &&
                              Boolean(formik.errors.toDate)
                            }
                            errorText={
                              isSubmitted || formik.touched.toDate
                                ? formik.errors.toDate
                                : ""
                            }
                            disabled={!formik.values.fromDate}
                          />
                        </div>
                      )}

                      {/* Travellers Field - Adjust column size based on trip type */}
                      <div
                        className={`${
                          formik.values.tripType === "Round Trip"
                            ? "col-md-4"
                            : "col-md-4"
                        } mb-3 position-relative`}
                      >
                        <MuiInput
                          placeholder="Enter Traveller(s), Class"
                          label="Traveller(s), Class"
                          isRequired={true}
                          isInvalid={
                            formik.touched.travellersDetail &&
                            Boolean(formik.errors.travellersDetail)
                          }
                          errorText={
                            formik.touched.travellersDetail &&
                            formik.errors.travellersDetail
                              ? formik.errors.travellersDetail
                              : ""
                          }
                          onClick={() => openPopup()}
                          onChange={(e: any) =>
                            formik.setFieldValue("travellersDetail", e)
                          }
                          onBlur={() =>
                            formik.setFieldTouched("travellersDetail", true)
                          }
                          value={formik.values.travellersDetail}
                        />

                        <div className="container">
                          {/* Traveller Dropdown */}
                          {isPopupOpen && (
                            <div
                              className="traveller-box position-absolute bg-white shadow p-3 rounded border"
                              style={{
                                top: "100%",
                                left: 0,
                                width: "100%",
                                zIndex: 999,
                              }}
                            >
                              <div className="">
                                <div className="traveller-selection">
                                  <div className="traveller-option">
                                    <label>Adults </label>
                                    <span>(12+ yrs)</span>
                                    <select
                                      value={formik.values.adults}
                                      onChange={(e) =>
                                        formik.setFieldValue(
                                          "adults",
                                          Number(e.target.value)
                                        )
                                      }
                                    >
                                      {[...Array(10).keys()].map((num) => (
                                        <option key={num + 1} value={num + 1}>
                                          {num + 1}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="traveller-option">
                                    <label>Children</label>
                                    <span> (2-12 yrs)</span>
                                    <select
                                      value={formik.values.child}
                                      onChange={(e) =>
                                        formik.setFieldValue(
                                          "child",
                                          Number(e.target.value)
                                        )
                                      }
                                    >
                                      {[...Array(5).keys()].map((num) => (
                                        <option key={num} value={num}>
                                          {num}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="traveller-option">
                                    <label>Infants</label>
                                    <span> (Below 2 yrs)</span>
                                    <select
                                      value={formik.values.infants}
                                      onChange={(e) =>
                                        formik.setFieldValue(
                                          "infants",
                                          Number(e.target.value)
                                        )
                                      }
                                    >
                                      {[...Array(3).keys()].map((num) => (
                                        <option key={num} value={num}>
                                          {num}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="class-selection">
                                  {travelClass?.map((cls) => (
                                    <label
                                      key={cls}
                                      className="radio-container"
                                    >
                                      <input
                                        type="radio"
                                        name="travelClass"
                                        value={cls}
                                        checked={
                                          formik.values.travelClass === cls
                                        }
                                        onChange={handleRadioChange}
                                      />
                                      <span className="checkmark" /> {cls}
                                    </label>
                                  ))}
                                </div>
                                <button
                                  className="done-btn mt-4"
                                  onClick={handleDone}
                                >
                                  Done
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* <div className="col-md-4 mb-3">
                        <MuiDropDown
                          placeholder="Select Airlines"
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={formik.values.preferredAirline}
                        />
                      </div> */}
                    </div>
                  )}

                  <div className="d-flex  pb-2 user-button w-full">
                    <MuiButton
                      label="Clear"
                      type="submit"
                      onClick={() => {
                        formik.resetForm();
                        setIsSubmitted(false); // ✅ Reset submission flag
                      }}
                      className=" clear-btn"
                    />
                    <MuiButton
                      label="Submit"
                      variant="contained"
                      size="large"
                      onClick={() => {
                        formik.handleSubmit(); // trigger validation
                      }}
                      className="me-2 get-btn"
                    />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default FlightSearch;
